export class PricePlan {
  id: number;
  title: string;
  price: string;
  price_currency?: string;
  default_users_slots?: number;
  stripe_id: string;
  addon_type?: string;
}
